import { render } from "./SearchBar.vue?vue&type=template&id=95361518&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=95361518&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-95361518"

export default script